import { useRoutes } from 'react-router-dom';

import { authRoutes } from './auth';

export function AuthApp(): JSX.Element | null {
  return useRoutes(authRoutes);
}
